import React from 'react'

var EventFormFieldDropdown = React.createClass({
  render: function() {
    const { onChange, label, name, value, response_options, required } = this.props;
    const option_nodes = [<option></option>].concat(response_options.map( (o, i) => {
      return <option key={o.id} value={o.name}>{o.label}</option>
    }));
    return(
      <div className="form-group">
        <label className="col-lg-2 control-label">{label}{ required ? '*' : undefined }</label>
        <div className="col-lg-10">
          <select className="form-control" name={name} value={value} onChange={e => onChange({[name] : e.target.value })}>
            { option_nodes }
          </select>
        </div>
      </div>
    );
  }
});

export default EventFormFieldDropdown;


// WEBPACK FOOTER //
// ./src/components/event_form_field_dropdown.js